$(document).ready(function() {
    initInputs();
    initMainMenu();
    initMobileActions();
    initActions();
    initGalleries();
    initSlideshow();
    initSelects();
    initCart();
    initSliders();
    initProducts();
    initAutocomplete();
    initTooltips();
    initFilters();
    initCategoryGrid();
    initNumbers();
    initLayout();
    processHeaderClass();
    initOrderForm();
    initCookieNotification();

    $('#back-to-top').toggleClass('fade', window.scrollY < window.innerHeight);
});

function resize() {
    setThumbnailPadding();
    setCatMenuWidth();
    resizeThumbnails();
}

function scroll() {
    processHeaderClass();
    $('#back-to-top').toggleClass('fade', window.scrollY < window.innerHeight);
}

var timo, timoScroll;
window.onresize = function() {
    clearTimeout(timo);
    timo = setTimeout(resize, 300);
};

window.onscroll = function() {
    clearTimeout(timoScroll);
    timoScroll = setTimeout(scroll, 10);
};

var overlay = $('#overlay');
overlay.click(function() {
    var target = $('#' + $(this).data('caller'));
    target.click();
});

function initMainMenu() {
    var categoryMenu = $('#category-menu');
    var categoryToggler = $('#category-toggler');
    var navLinks = $('.left .nav-link', categoryMenu);
    var subCats = $('.subcategory-wrap', categoryMenu);

    initCategoryMenu();
    initSubmenu();
    initMobileSearch();

    function initCategoryMenu() {
        var activeSubcat,
            activeLink = null;

        $('.navbar-toggler').click(function() {
            $(this).toggleClass('active');
            overlay.data('caller', $(this).attr('id'));
            overlay.toggleClass('show', $(this).hasClass('active'));
        });

        categoryToggler.click(function(e) {
            e.preventDefault();
            categoryMenu.toggleClass('show');
            $(this).toggleClass('active', categoryMenu.hasClass('show'));
            overlay.data('caller', $(this).attr('id'));
            overlay.toggleClass(
                'show show-header',
                categoryMenu.hasClass('show')
            );
            return false;
        });

        $(document).on('click', function(e) {
            var target = e.relatedTarget ? $(e.relatedTarget) : $(e.target);
            if (typeof target != 'undefined' && target != 'null') {
                if (
                    target.parents('#category-menu-wrap').length > 0 ||
                    target.is('#category-menu-wrap') ||
                    target.parents('.bottom').length > 0 ||
                    target.is('.bottom')
                ) {
                } else {
                    $('#category-menu').removeClass('show');
                    $('#category-toggler').removeClass('active');
                    overlay.removeClass('show');
                }
            } else {
                $('#category-menu').removeClass('show');
                $('#category-toggler').removeClass('active');
                overlay.removeClass('show');
            }
        });

        $(document).on('keyup', function(e) {
            if (e.keyCode === 27) {
                $('#category-menu').removeClass('show');
                $('#category-toggler').removeClass('active');
                overlay.removeClass('show');
            }
        });

        $(categoryMenu).on('keyup', function(e) {
            if (e.keyCode === 39) {
                activeSubcat.focus();
            }

            if (e.keyCode === 37) {
                activeLink.focus();
            }
        });

        $('.left .nav-link').on(
            'mouseenter mouseleave focusin focusout',
            function(e) {
                activeLink = $(this);
                switchActiveSubMenu();
                e.stopPropagation();
            }
        );

        subCats.on('focus', function(e) {
            e.stopImmediatePropagation();
            $('a', $(this))
                .eq(0)
                .focus();
            return false;
        });

        function switchActiveSubMenu() {
            var navItem = activeLink.closest('.nav-item');
            navItem.addClass('hovered');

            $('.left .nav-item', categoryMenu)
                .not(navItem)
                .removeClass('hovered');
            activeSubcat = subCats.filter(function(index, element) {
                return (
                    $(element).data('category') == activeLink.data('category')
                );
            });

            subCats.not(activeSubcat).removeClass('active');
            activeSubcat.addClass('active');
        }
        setCatMenuWidth();
    }

    function initSubmenu() {
        $('.category-menu .nav-item')
            .on('focus', '.nav-link', function() {
                $(this)
                    .parents('.nav-item')
                    .addClass('hovered');
            })
            .on('blur mouseleave', '.nav-link', function() {
                $('.nav-item').removeClass('hovered');
            });

        $('.category-menu .submenu-toggle').click(function() {
            $(this)
                .siblings('.submenu')
                .slideToggle(160);
            $(this).toggleClass('show');
            return false;
        });
    }

    $('#main-navigation .submenu-toggle').click(function() {
        $(this)
            .parents('.nav-item')
            .toggleClass('hovered');
        if (
            $(this)
                .parents('.nav-item')
                .hasClass('hovered')
        ) {
            $(this)
                .siblings('.submenu')
                .slideDown(300);
        } else {
            $(this)
                .siblings('.submenu')
                .slideUp(300);
            $(this).blur();
        }
        return false;
    });

    function initMobileSearch() {
        var toggler = $('#header .bottom .search-toggler');

        toggler.click(function() {
            $(this).toggleClass('active');
            if ($(this).hasClass('active')) {
                $('form.search-wrap').slideDown(200);
            } else {
                $('form.search-wrap').slideUp(200);
            }
            overlay.data('caller', $(this).attr('id'));
            overlay.toggleClass('show', $(this).hasClass('active'));
        });
    }
}

function initSlideshow() {
    var slideshow = $('#slideshow');
    if (slideshow.length < 1) {
        return false;
    }
    var thumbnailContainer = $('.slide-thumbs', slideshow);
    var thumbs = $('.thumb', thumbnailContainer);
    var mainContainer = $('.carousel-inner', slideshow);
    var slideInterval = null;

    initLargeImage();
    if (thumbnailContainer.length < 1) {
        return false;
    }
    initThumbnails();

    function initLargeImage() {
        mainContainer.swipeDetector();
        mainContainer.on('swipeRight.sd', function() {
            slideshow.carousel('prev');
        });
        mainContainer.on('swipeLeft.sd', function() {
            slideshow.carousel('next');
        });

        slideshow.on('slide.bs.carousel', function(event) {
            thumbnailContainer.slick('slickGoTo', event.to);
        });
    }

    function initThumbnails() {
        var slideshow_speed = 7000;
        if (typeof SLIDESHOW_SPEED != 'undefined') {
            slideshow_speed = SLIDESHOW_SPEED;
        }

        var slides_to_show = 3;
        if (typeof SLIDES_TO_SHOW != 'undefined') {
            slides_to_show = SLIDES_TO_SHOW;
            slides_to_show =
                slides_to_show <= thumbs.length
                    ? slides_to_show
                    : thumbs.length;
        }

        thumbnailContainer.on('init', function(event, slick) {
            var time = 0;
            $('.thumb.slick-active').each(function() {
                var elem = $(this);
                setTimeout(function() {
                    elem.addClass('show');
                }, time);
                time += 300;
            });
            $('.thumb:not(.slick-active)').addClass('show');
        });

        thumbnailContainer.on('beforeChange', function(
            event,
            slick,
            currentSlide,
            nextSlide
        ) {
            slideshow.carousel(nextSlide);
            thumbs.removeClass('active');
            thumbs.eq(nextSlide).addClass('active');
            clearInterval(slideInterval);
            manualSliding();
        });

        var center_mode = slides_to_show % 2 == 1;

        thumbnailContainer.slick({
            vertical: true,
            arrows: false,
            centerMode: center_mode,
            slidesToShow: slides_to_show,
            infinite: true,
            centerPadding: '0',
            verticalSwiping: true,
            swipeToSlide: true,
            initialSlide: 0,
            pauseOnFocus: false,
            pauseOnHover: false,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        });

        setThumbnailPadding();

        setTimeout(function() {
            thumbs.eq(0).addClass('active');
            manualSliding();
        });

        if (
            thumbs.length <=
            thumbnailContainer.get(0).slick.options.slidesToShow
        ) {
            slideshow.find('.slick-track').addClass('no-transform');
        }

        function manualSliding() {
            slideInterval = setInterval(function() {
                if (
                    thumbnailContainer.slick('slickCurrentSlide') <
                    thumbs.length - 1
                ) {
                    thumbnailContainer.slick(
                        'slickGoTo',
                        thumbnailContainer.slick('slickCurrentSlide') + 1
                    );
                } else {
                    thumbnailContainer.slick('slickGoTo', 0);
                }
            }, slideshow_speed);
        }

        fixVerticalSliding();

        thumbs.click(function() {
            thumbnailContainer.slick('slickGoTo', $(this).data('slide-to'));
        });
    }
}

function setThumbnailPadding() {
    var slideshow = $('#slideshow');
    if (slideshow.length < 1) {
        return false;
    }
    var carouselInner = $('.carousel-inner', slideshow);
    var thumbnailContainer = $('.slide-thumbs', slideshow);
    var activeSlides = $('.slick-active', thumbnailContainer);
    var allSlides = $('.slick-slide', thumbnailContainer);
    var activeSlideCount = activeSlides.length;
    activeSlideCount = $('.slide-thumbs', slideshow).slick(
        'slickGetOption',
        'slidesToShow'
    );

    if (activeSlides.length == 0) {
        activeSlideCount = 3;
    }

    $('.thumb', thumbnailContainer).css({
        'margin-top': '0',
        'margin-bottom': '0'
    });

    thumbnailContainer.css({
        'margin-top': '0',
        'margin-bottom': '0'
    });

    var slideHeight = activeSlides.eq(0).outerHeight();
    var proportion = 1.78; //16:9 (9:16) //proporcija, kādā tiks attēloti thumbnaili
    var thumbWrapWidth = slideHeight * proportion;

    slideHeight =
        (thumbnailContainer.parent().outerHeight() / activeSlideCount) * 0.95; //thumbnaili aizņem 95% no atvēlētā laukuma

    var padding =
        (thumbnailContainer.parent().outerHeight() -
            slideHeight * activeSlideCount) /
        activeSlideCount; // neizmantoto laukumu izdala ar thumbnailu skaitu, lai zinātu, cik lielām jābūt atstarpēm

    allSlides.css({
        height: slideHeight,
        width: slideHeight * proportion
    });

    $('.slide-thumb-wrap').css({
        // 'width': thumbWrapWidth,
        // 'flex-basis': thumbWrapWidth,
        'margin-left': padding * 2
    });

    thumbnailContainer.css({
        'margin-top': padding * -1,
        'margin-bottom': padding * -1
    });

    $('.thumb', thumbnailContainer).css({
        'margin-top': padding,
        'margin-bottom': padding
    });
}

/**
 * pievieno trūkstošo vertikālās slidināšanas funkcionalitāti, kas ļauj pārtīt vairākus slaidus
 */
function fixVerticalSliding() {
    $('.slide-thumbs').each(function() {
        this.slick.getSlideCount = function() {
            var _ = this,
                slidesTraversed,
                swipedSlide,
                centerOffset;

            var ydir =
                _.touchObject.startY > _.touchObject.curY ? 'top' : 'bottom';
            centerOffset =
                _.options.centerMode === true
                    ? _.slideWidth * Math.floor(_.options.slidesToShow / 2)
                    : 0;

            if (_.options.swipeToSlide === true) {
                _.$slideTrack.find('.slick-slide').each(function(index, slide) {
                    var offsetPoint = slide.offsetLeft,
                        outerSize = $(slide).outerWidth();

                    if (_.options.vertical === true) {
                        offsetPoint = slide.offsetTop;
                        if (ydir == 'bottom') {
                            offsetPoint =
                                slide.offsetTop + $(slide).outerHeight();
                        }
                        outerSize = $(slide).outerHeight();
                    }

                    if (
                        offsetPoint - centerOffset + outerSize / 2 >
                        _.swipeLeft * -1
                    ) {
                        swipedSlide = slide;
                        return false;
                    }
                });
                slidesTraversed =
                    Math.abs(
                        $(swipedSlide).attr('data-slick-index') - _.currentSlide
                    ) || 1;

                if (_.options.vertical === true && ydir !== 'bottom') {
                    slidesTraversed =
                        slidesTraversed > 1 ? slidesTraversed - 1 : 1;
                }

                return slidesTraversed;
            } else {
                return _.options.slidesToScroll;
            }
        };

        this.slick.getNavigableIndexes = function() {
            var _ = this,
                breakPoint = 0,
                counter = 0,
                indexes = [],
                max;

            if (_.options.infinite === false) {
                max = _.slideCount;
            } else {
                breakPoint = _.slideCount * -1;
                counter = _.slideCount * -1;
                max = _.slideCount * 2;
            }

            while (breakPoint < max) {
                indexes.push(breakPoint);
                breakPoint = counter + _.options.slidesToScroll;
                counter +=
                    _.options.slidesToScroll <= _.options.slidesToShow
                        ? _.options.slidesToScroll
                        : _.options.slidesToShow;
            }
            return indexes;
        };
    });
}

function initInputs() {
    var inputs = $(
        ':text, :password, [type="email"], [type="tel"], [type="number"], textarea'
    );

    if (
        /Chrome/.test(navigator.userAgent) &&
        /Google Inc/.test(navigator.vendor)
    ) {
        inputs.each(function() {
            if ($(this).is('*:-webkit-autofill')) {
                $(this).val('******');
            }
        });
    }

    var filledInputs = inputs.filter(function(index, element) {
        return $(element).val() != '';
    });

    filledInputs.addClass('filled');

    $(document).on('keyup change blur', 'input, textarea', function() {
        if ($(this).val()) {
            $(this).addClass('filled');
        } else {
            $(this).removeClass('filled');
        }
    });
}

function initSliders() {
    var sliders = $('.slider-wrap');

    sliders.each(function() {
        $(this).slick({
            autoplay: true,
            autoplaySpeed: 10,
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: true,
            arrows: false,
            pauseOnFocus: false,
            pauseOnHover: false,
            focusOnSelect: false,
            draggable: false,
            swipe: false,
            waitForAnimate: true,
            speed: 4000,
            cssEase: 'linear',
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 360,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    });
}

function initSelects() {
    var selects = $('select.styled:not(.done)');
    styleSelects();

    $(document).on('click', 'select.styled', function() {
        $(this)
            .parent()
            .focus();
    });

    $(document).on('click', '.select-value', function() {
        $(this)
            .parent()
            .focus();
    });

    $(document).on('click', '.select-options .option', function(e) {
        var wrap = $(this).parents('.select-wrap');
        var selectValue = wrap.find('.select-value');
        wrap.removeClass('clicked');
        selectValue.html($(this).html());
        wrap.find('select')
            .val($(this).attr('data-value'))
            .change();
        $('.option', wrap).removeClass('selected');
        $(this).addClass('selected');
        if ($(this).attr('data-default')) {
            selectValue.removeClass('selected');
        } else {
            selectValue.addClass('selected');
        }
        e.stopImmediatePropagation();
        e.stopPropagation();
    });

    $(document).on('keypress', '.select-options .option', function(e) {
        if (e.charCode == 13) {
            var wrap = $(this).parents('.select-wrap');
            var selectValue = wrap.find('.select-value');
            $('.option', wrap).removeClass('selected');
            $(this).addClass('selected');
            if ($(this).attr('data-default')) {
                selectValue.removeClass('selected');
            } else {
                selectValue.addClass('selected');
            }
            selectValue.html($(this).html());
            wrap.find('select')
                .val($(this).attr('data-value'))
                .change();
        }
    });

    $(document).on('focusin', '.select-wrap', function(e) {
        $(this).addClass('clicked');
        e.stopImmediatePropagation();
        e.stopPropagation();
    });

    $(document).on('focusout', '.select-wrap', function(e) {
        $(this).removeClass('clicked');
        e.stopImmediatePropagation();
        e.stopPropagation();
    });
    // find option by pressed keys
    var typingTimer;
    var doneTypingInterval = 700;
    var needle = '';

    $(document).on('keyup', '.select-wrap', function(e) {
        if (e.which == 27) {
            $(this).removeClass('clicked');
            return false;
        }

        needle += e.key;
        clearTimeout(typingTimer);
        selectWrap = $(this);

        typingTimer = setTimeout(function() {
            doneTyping(selectWrap);
        }, doneTypingInterval);
    });

    function doneTyping(selectWrap) {
        var opt = $('.option', selectWrap).filter(function() {
            var text = $(this)
                .text()
                .toLowerCase()
                .replace(/\s/g, '');
            needle = needle.replace(/\s/g, '');
            return text.indexOf(needle) === 0;
        });
        if (opt.length > 0) {
            selectWrap
                .find('select-options')
                .mCustomScrollbar('scrollTo', opt.eq(0).position().top);
            opt.eq(0).click();
        }
        needle = '';
    }
}

function styleSelects() {
    var selects = $('select.styled:not(.done)');

    selects.each(function() {
        $(this).wrap('<div class="select-wrap"></div>');
        var wrap = $(this).parent();
        var selected = $(this).find(':selected');
        var def = $(this).find('[data-default="true"]');
        var notdefault = '';
        selected.attr('selected', true);

        if (selected.val() != def.val()) {
            notdefault = true;
        }

        wrap.attr('tabindex', '0');
        wrap.append(
            '<div class="select-value ' +
                (notdefault ? 'selected' : '') +
                '">' +
                (typeof selected.data('background') == 'string'
                    ? '<span class="img" style="background:' +
                      selected.data('background') +
                      '"></span>'
                    : '') +
                selected.text() +
                '</div>'
        );
        var html = '<div class="select-options">';
        $(this)
            .find('option')
            .each(function() {
                html +=
                    '<div class="option ' +
                    ($(this).attr('selected') ? 'selected' : '') +
                    '" data-value="' +
                    $(this).val() +
                    '" ' +
                    ($(this).data('default') ? 'data-default="true"' : '') +
                    ' tabindex="0">' +
                    (typeof $(this).data('background') == 'string'
                        ? '<span class="img" style="background:' +
                          $(this).data('background') +
                          '"></span>'
                        : '') +
                    $(this).text() +
                    '</div>';
            });
        html += '</div>';

        wrap.append(html);
        wrap.addClass($(this).attr('class'));
        $(this).addClass('done');

        if (
            $('.select-options', wrap).outerHeight() >=
            parseInt($('.select-options', wrap).css('max-height'))
        ) {
            $('.select-options', wrap).mCustomScrollbar({
                scrollInertia: 150
            });
        }
    });
}

function initProducts() {
    $(document)
        .on('mouseenter', '.product', function(e) {
            var element = $(this);
            var width =
                element.outerWidth() + 40 <
                $(this)
                    .parent()
                    .width()
                    ? element.outerWidth() + 40
                    : $(this)
                          .parent()
                          .width();
            var diff = width - element.outerWidth();
            var height =
                $(this).find('.compare').length > 0
                    ? element.outerHeight() + 44
                    : element.outerHeight() + 22;
            if (
                $(this)
                    .parents('.product-container')
                    .hasClass('list-view')
            ) {
                var width = element.outerWidth();
                var diff = width - element.outerWidth();
                var height = element.outerHeight() + 22;
            }

            element.find('.product-background, .tags').css({
                width: width,
                height: height,
                transform: 'translate(' + (diff / 2) * -1 + 'px, ' + '-11px)'
            });
            element.addClass('hovered');
        })
        .on('mouseleave', '.product', function(e) {
            var element = $(this);
            element.find('.product-background, .tags').css({
                height: '100%',
                width: '100%',
                transform: 'translate(0, 0)'
            });
            element.removeClass('hovered');
        });

    $(document)
        .on('focus', '.product .compare a', function(e) {
            $(this)
                .parents('.product')
                .trigger('mouseenter');
        })
        .on('blur', '.product .compare a', function(e) {
            $(this)
                .parents('.product')
                .trigger('mouseleave');
        });
}

function initTooltips() {
    $('[data-toggle="tooltip"]').tooltip({
        trigger: 'hover'
    });
}

function initAutocomplete() {
    var input = $('#search-needle');
    var suggestions = $('#autocomplete-suggestions');

    input.on('keyup', function(e) {
        if (e.keyCode === 27) {
            $('.visible').removeClass('visible');
        }
    });
}

function addScrollbar(element, outside) {
    element.mCustomScrollbar('destroy');
    element.mCustomScrollbar({
        scrollbarPosition: outside ? 'outside' : 'inside',
        scrollInertia: 150
    });
}

function initActions() {
    $(document).on('keyup', '.action-wrap', function(e) {
        if (e.keyCode === 27) {
            $('.visible').removeClass('visible');
        }
    });

    $('.action-menu').css({
        // 'max-height': $(window).height() - $('#header').height()
    });

    $(document).on('click', function(e) {
        if (!clickInside(e, '.action-wrap')) {
            $('.visible')
                .not($('#to-top'))
                .removeClass('visible');
        }
    });

    $(document).on('click', '.action-toggle', function(e) {
        var actionWrap = $(this).closest('.action-wrap');
        var menu = $('.action-menu', actionWrap);

        $('.action-menu.visible')
            .filter(function(index, element) {
                return !$(element).is(menu);
            })
            .removeClass('visible');

        //ja nav menu, toggleris aizved uz norādīto linku
        if (menu.length < 1) {
            return true;
        }

        menu.width(menu.width());
        menu.css({
            // 'max-height': $(window).height() - $('#header').height()
        });

        var toggler = $('.action-toggle', actionWrap);
        menu.toggleClass('visible');
        toggler.toggleClass('visible', menu.hasClass('visible'));

        var rightMax = $(window).width() - 17;
        var menuLeft = menu.offset().left;
        var menuRight = menuLeft + menu.width();

        if ($(window).width() < 991) {
            rightMax = $(window).width();
        }

        e.preventDefault();
        if (menuRight > rightMax) {
            menu.offset({
                left: menuLeft - Math.abs(rightMax - menuRight) * 2
            });
            return false;
        }

        if (menuLeft <= 17) {
            if ($(window).width() < 991) {
                menu.offset({ left: 0 });
            } else {
                menu.offset({ left: menuLeft + Math.abs(17 - menuLeft) });
            }
            return false;
        }

        menu.attr('style', '');
        menuLeft = menu.offset().left + menu.position().left / 2;
        menuRight = menuLeft + menu.width();
        if (menuRight > rightMax) {
            menu.offset({
                left: menuLeft - Math.abs(rightMax - menuRight) * 2
            });
        }

        return false;
    });
}

function clickInside(e, selector) {
    var target = e.relatedTarget ? $(e.relatedTarget) : $(e.target);
    if (typeof target != 'undefined' && target != 'null') {
        if (target.parents(selector).length > 0 || target.is(selector)) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
}

function initCart() {
    initSmallCarts();
    initBigCart();

    function initSmallCarts() {
        var smallCarts = $('.small-cart');
        if (smallCarts.length < 1) {
            return false;
        }
        smallCarts.each(function() {
            addScrollbar($(this), false);
        });
    }

    function initBigCart() {}
}

function initFilters() {
    if ($('#filter-form').length < 1) {
        return;
    }

    var filterTimo;
    var form = $('#filter-form');
    var submitTimeout = 0;
    var filters = $('.filter', form);

    if (typeof FORM_SUBMIT_TIMEOUT != 'undefined') {
        submitTimeout = FORM_SUBMIT_TIMEOUT;
    }

    initPriceFilter();
    addScrolls();

    function addScrolls() {
        if (filters.length < 1) {
            return false;
        }

        $('.content', filters).each(function() {
            var collapsed = false;
            var removeClass = true;

            if ((collapsed = $(this).parents('.collapse'))) {
                if (collapsed.hasClass('show')) {
                    removeClass = false;
                }
                collapsed.addClass('show');
            }

            $(this).height($(this).height());

            if (removeClass) {
                collapsed.removeClass('show');
            }

            if ($(this).find('.price-inputs').length > 0) {
                return;
            }

            addScrollbar($(this));
        });
    }

    $('[type="checkbox"], [type="radio"]', form).on('change', function() {
        submitForm();
    });

    function initPriceFilter() {
        if ($('.price-inputs').length < 1) {
            return false;
        }

        var minPrice = $('.price-inputs [name="price-from"]');
        var maxPrice = $('.price-inputs [name="price-to"]');
        var min = parseInt(minPrice.attr('min'));
        var max = parseInt(maxPrice.attr('max'));
        var priceTimo;
        var slider = $('.slider', form).slider({
            animate: 'fast',
            min: min,
            max: max,
            range: true,
            values: [minPrice.val(), maxPrice.val()],
            slide: function(event, ui) {
                if (ui.values[0] >= ui.values[1]) {
                    return false;
                }
                minPrice.val(ui.values[0]);
                maxPrice.val(ui.values[1]);
            },
            change: function() {
                submitForm();
            }
        });

        $('.price-inputs input').on('blur', function(e) {
            clearTimeout(priceTimo);
            priceTimo = setTimeout(function() {
                var mip = parseInt(minPrice.val());
                var map = parseInt(maxPrice.val());
                var sliderValues = slider.slider('option', 'values');

                if (mip == sliderValues[0] && map == sliderValues[1]) {
                    return;
                }

                if (isNaN(mip)) {
                    mip = 0;
                }

                if (isNaN(map)) {
                    map = mip;
                }

                if (mip <= min) {
                    minPrice.val(min);
                }
                if (map > max) {
                    maxPrice.val(max);
                }
                if ($(this).attr('id') == 'price-from') {
                    if (mip >= map) {
                        minPrice.val(map - 1);
                    }
                } else {
                    if (mip >= map) {
                        maxPrice.val(mip + 1);
                    }
                }

                if (e.originalEvent) {
                    maxPrice.trigger('change');
                    minPrice.trigger('change');
                }
                slider.slider('values', [minPrice.val(), maxPrice.val()]);
                submitForm();
            }, 10);
        });
    }

    function submitForm() {
        clearTimeout(filterTimo);
        filterTimo = setTimeout(function() {
            form.submit();
        }, submitTimeout);
    }
}

function setCatMenuWidth() {
    if ($('#category-menu').length < 1) {
        return false;
    }

    if ($(window).outerWidth() < 1230) {
        var width = $(window).width() - $('#category-menu').offset().left * 2;
        $('#category-menu').css({
            'max-width': width
        });
    } else {
        $('#category-menu').attr('style', '');
    }
}

function initCategoryGrid() {
    $('.cat-container .cat span').fitText(1, {
        maxFontSize: '32px'
    });
    $('.cat-container .h-2 .cat span').fitText(1, {
        maxFontSize: '64px'
    });
}

function addToCart(target) {
    target.toggleClass('added');
}

function initNumbers() {
    var numberTimo;
    var numberInt;

    $(document).on('click', '.number-wrap .number-control', function() {
        var input = $(this).siblings('input');
        var min = parseInt(input.attr('min'));
        var max = parseInt(input.attr('max'));

        if ($(this).hasClass('minus')) {
            decrease(input, min);
        } else {
            increase(input, max);
        }
        return false;
    });

    $(document).on('mousedown', '.number-wrap .number-control', function() {
        var input = $(this).siblings('input');
        var min = parseInt(input.attr('min'));
        var max = parseInt(input.attr('max'));
        var speed = 500;

        if ($(this).hasClass('minus')) {
            numberTimo = setTimeout(function() {
                numberInt = setInterval(function() {
                    decrease(input, min);
                }, 50);
            }, 500);
        } else {
            numberTimo = setTimeout(function() {
                numberInt = setInterval(function() {
                    increase(input, max);
                }, 50);
            }, 500);
        }
        return false;
    });

    $(document).on('mouseup', '.number-wrap .number-control', function() {
        clearInterval(numberInt);
        clearInterval(numberTimo);
    });

    $(document).on(
        'change keyup',
        '.number-wrap input[type="number"]',
        function() {
            var input = $(this);
            var min = parseInt(input.attr('min'));
            var max = parseInt(input.attr('max'));

            if (input.val() > max) {
                input.val(max);
            }
            if (input.val() < min) {
                input.val(min);
            }
        }
    );

    function increase(input, max) {
        if (max) {
            if (input.val() >= max) {
                return false;
            }
        }
        input.val(parseInt(input.val()) + 1);
    }

    function decrease(input, min) {
        if (input.val() > min) {
            input.val(input.val() - 1);
        }
    }
}

function initGalleries() {
    var galleries = $('.gallery');
    if (galleries.length < 1) {
        return false;
    }

    galleries.each(function() {
        var wrap = $(this);
        var mainImage = $('.main-image', wrap);
        var thumbWrap = $('.thumbnails', wrap);
        var thumbnails = $('.thumbnail', thumbWrap);

        thumbWrap.css({
            'max-width': wrap.width()
        });

        thumbWrap.addClass('owl-carousel').owlCarousel({
            margin: 20,
            responsiveBaseElement: '.gallery',
            items: 4
        });

        $('.thumbnail', thumbWrap).click(function() {
            var current = thumbnails.index(thumbnails.filter('.current'));
            var next = thumbnails.index($(this));

            thumbnails.removeClass('current');
            $(this).addClass('current');
            $('.carousel', wrap).carousel($(this).data('slide'));

            scrollThumbs(current, next);
        });

        function scrollThumbs(current, next) {
            if (current < next) {
                thumbWrap.trigger('next.owl.carousel');
            }

            if (current > next) {
                thumbWrap.trigger('prev.owl.carousel');
            }
        }

        var heights = $('.carousel-item', wrap).map(function() {
            return $(this).outerHeight();
        });

        maxHeight = Math.max.apply(null, heights);
        mainImage.css({
            height: maxHeight
        });

        if ($(this).hasClass('inited')) {
            return;
        }
        $('.carousel-item', mainImage)
            .on('mouseover', function() {
                $(this)
                    .parents('.gallery')
                    .addClass('hover');
                $(this)
                    .find('.photo')
                    .css({
                        transform: 'scale(' + $(this).attr('data-scale') + ')'
                    });
            })
            .on('mouseout', function() {
                $(this)
                    .parents('.gallery')
                    .removeClass('hover');
                $(this)
                    .find('.photo')
                    .css({ transform: 'scale(1)' });
            })
            .on('mousemove', function(e) {
                $(this)
                    .find('.photo')
                    .css({
                        'transform-origin':
                            ((e.pageX - $(this).offset().left) /
                                $(this).width()) *
                                100 +
                            '% ' +
                            ((e.pageY - $(this).offset().top) /
                                $(this).height()) *
                                100 +
                            '%'
                    });
            })
            .each(function() {
                if (
                    typeof $(this).attr('data-image') == 'undefined' ||
                    $(this).attr('data-image') == ''
                ) {
                    return;
                }

                var anchor =
                    $(this).find('.embed-responsive-item').length > 0
                        ? $(this).find('.embed-responsive-item')
                        : $(this);
                anchor.append('<div class="photo"></div>');
                anchor.find('.photo').css({
                    'background-image':
                        'url(' + $(this).attr('data-image') + ')'
                });
            });

        $(this).addClass('inited');
    });
}

$(window).on('load', function() {
    $('.gallery').each(function() {
        var wrap = $(this);
        var mainImage = $('.main-image', wrap);

        $('.carousel-item', mainImage).each(function() {
            $(this)
                .find('img')
                .hide();

            $(this)
                .find('.photo')
                .css({
                    width: $(this)
                        .find('img')
                        .width(),
                    height: $(this)
                        .find('img')
                        .height(),
                    position: 'relative',
                    display: 'block'
                });
        });
    });
});

function resizeThumbnails() {
    $('.thumbnails').each(function() {
        var thumbs = $(this);

        thumbs.siblings('.main-image').css({
            height: 'auto'
        });
        thumbs
            .trigger('destroy.owl.carousel')
            .removeClass('owl-carousel')
            .css({
                'max-width': 'unset'
            });

        setTimeout(function() {
            initGalleries();
        }, 10);
    });
}

function initMap(params) {
    if (typeof google == 'undefined') {
        return;
    }
    var gm = google.maps;

    if ($(params.map).length < 1) {
        return;
    }

    map = new google.maps.Map(params.map, {
        zoom: params.zoom,
        center: new gm.LatLng(params.center.lat, params.center.lng),
        zoomControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false
    });

    map.scrollwheel = false;

    for (var i in params.markers) {
        if (params.markers.hasOwnProperty(i)) {
            var element = params.markers[i];

            var m = new MarkerWithLabel({
                position: new gm.LatLng(
                    element.position.lat,
                    element.position.lng
                ),
                icon: ' ',
                map: map,
                labelContent: element.labelContent,
                labelAnchor: new google.maps.Point(15, 40)
            });
        }
    }
}

function initLayout() {
    var contentHeight = 0;

    $('body')
        .children()
        .not('#overlay, script')
        .each(function() {
            contentHeight += $(this).outerHeight();
        });

    if ($(window).height() - contentHeight > 0) {
        $('body>footer').css({
            'margin-top': $(window).height() - contentHeight
        });
    }
}

var headerElem = document.getElementById('header');
if (headerElem) {
    var headerStartHeight = headerElem.clientHeight;
}

var prevScrollTop = 0;

function processHeaderClass() {
    if (!headerElem) {
        return false;
    }

    if (Math.abs(prevScrollTop - window.scrollY) > 10) {
        $(headerElem).toggleClass(
            'scroll-down',
            prevScrollTop < window.scrollY
        );
        $(headerElem).toggleClass('scroll-up', prevScrollTop > window.scrollY);
    }

    if (window.scrollY >= headerStartHeight) {
        headerElem.classList.add('scrolled');
    } else {
        headerElem.classList.remove('scrolled');
    }
    prevScrollTop = window.scrollY;
}

$(document).on('click', '.layout-wrap .layout', function() {
    $('.layout-wrap .layout').removeClass('active');
    if ($(this).hasClass('grid')) {
        $('.product-container').removeClass('list-view');
        $('.layout-wrap .layout.grid').addClass('active');
    } else {
        $('.product-container').addClass('list-view');
        $('.layout-wrap .layout.list').addClass('active');
    }
    return false;
});

$(function() {
    var monthNames =
        typeof MONTH_NAMES != 'undefined'
            ? MONTH_NAMES
            : $.datepicker._defaults.montNames;
    var monthNamesShort =
        typeof MONTH_NAMES_SHORT != 'undefined'
            ? MONTH_NAMES_SHORT
            : $.datepicker._defaults.montNamesShort;
    var dayNames =
        typeof DAY_NAMES != 'undefined'
            ? DAY_NAMES
            : $.datepicker._defaults.dayNames;
    var dayNamesShort =
        typeof DAY_NAMES_SHORT != 'undefined'
            ? DAY_NAMES_SHORT
            : $.datepicker._defaults.dayNamesShort;
    var dayNamesMin =
        typeof DAY_NAMES_MIN != 'undefined'
            ? DAY_NAMES_MIN
            : $.datepicker._defaults.dayNamesMin;

    $('.datepicker').datepicker({
        dateFormat: 'dd.mm.yy',
        firstDay: 1,
        showOtherMonths: true,
        selectOtherMonths: true,
        monthNames: monthNames,
        monthNamesShort: monthNamesShort,
        dayNames: dayNames,
        dayNamesShort: dayNamesShort,
        dayNamesMin: dayNamesMin,
        minDate: 0,
        beforeShow: function(input, inst) {
            inst.dpDiv.css({
                marginLeft: input.offsetWidth - inst.dpDiv.width() - 2 + 'px'
            });
            setTimeout(function() {
                if (inst.dpDiv.offset().top < $(input).offset().top) {
                    inst.dpDiv.addClass('above');
                } else {
                    inst.dpDiv.removeClass('above');
                }
            }, 0);
        }
    });
});

function initOrderForm() {
    var wrap = $('#order-form');

    if (wrap.length < 1) {
        return;
    }

    wrap.on(
        'change',
        'input[type="radio"], input[type="checkbox"]',
        function() {
            var related = $('[data-selector="' + $(this).attr('name') + '"]');
            if (related.length < 1) {
                return;
            }

            var child = $('[data-parent="' + $(this).val() + '"]');
            if ($(this).attr('type') == 'radio') {
                related.hide();
                related.find('input').prop('disabled', true);
                child.show();
                child.find('input').prop('disabled', false);
            } else if ($(this).attr('type') == 'checkbox') {
                if ($(this).prop('checked')) {
                    related.find('input').prop('disabled', true);
                    related.hide();
                } else {
                    related.show();
                    related.find('input').prop('disabled', false);
                }
            }
        }
    );

    $('input[type="radio"]:checked', wrap).change();
}

$('#back-to-top').click(function(event) {
    event.preventDefault();
    $('html, body').animate(
        {
            scrollTop: 0
        },
        1000
    );
});

$('.add-to-basket, .add-to-wishlist, .compare > a, a.compare').click(function(
    e
) {
    e.preventDefault();
    var elem = $(this);

    $.ajax({
        type: 'GET',
        url: elem.attr('href'),
        success: function(response) {
            var data = response;
            addToSomething(data, e);
        }
    });
});

function addToSomething(data, e) {
    var added_message_timeout = 5000;
    if (typeof ADDED_MESSAGE_TIMEOUT != 'undefined') {
        added_message_timeout = ADDED_MESSAGE_TIMEOUT;
    }
    var countElement;

    switch (data.action) {
        case 'cart':
            if (data.status != 'success') {
                return false;
            }
            data.class = 'dt-cart';
            countElement = $('.cart-wrap .indicator');
            break;

        case 'wish':
            countElement = $('.wishlist-wrap .indicator');
            data.class = 'dt-heart';
            var hrefElem = $(e.target).parents('.add-to-wishlist');

            if (data.status == 'success') {
                hrefElem.addClass('added');
                hrefElem
                    .attr('title', hrefElem.data('remove-text'))
                    .tooltip('_fixTitle')
                    .tooltip('show');
            } else if (data.status == 'removed') {
                $(e.target)
                    .parents('.add-to-wishlist')
                    .removeClass('added');
                hrefElem
                    .attr('title', hrefElem.data('add-text'))
                    .tooltip('_fixTitle')
                    .tooltip('show');
                updateCount(countElement, data);
            }
            break;

        case 'compare':
            if (data.status != 'success') {
                return false;
            }
            data.class = 'dt-scales';
            addToCompare(data);
            break;

        default:
            break;
    }

    var message = $('#add-to-cart-message-proto')
        .clone()
        .addClass('add-to-cart-message')
        .attr('id', '');

    message.find('.left a').attr('href', data.pageUrl);
    message.find('.left span').text(data.leftText);
    message.find('.right a').attr('href', data.rightUrl);
    message.find('.name a').text(data.name);
    message.find('.image img').attr('src', data.image);
    if (data.prices.new) {
        message.find('.item-price .new-price span').text(data.prices.new);
    } else {
        message.find('.item-price .new-price').remove();
    }
    if (data.prices.old) {
        message.find('.item-price .price span').text(data.prices.old);
    } else {
        message.find('.item-price .price').remove();
    }
    message.find('.buttons .btn').attr('href', data.pageUrl);
    message.find('.buttons .btn').text(data.buttonText);

    message.find('.left i').addClass(data.class);

    $('body').append(message);
    setTimeout(function() {
        message.addClass('show');
    }, 100);

    setTimeout(function() {
        closeMessage(message);
    }, added_message_timeout);

    updateCount(countElement, data);
}

function updateCount(countElement, data) {
    if (typeof countElement != 'undefined') {
        addLoading(countElement);
        countElement.text(data.totalCount);
        countElement.toggleClass('show', data.totalCount > 0);

        setTimeout(function() {
            removeLoading(countElement);
        }, 500);
    }
}

function closeMessage(message) {
    message.removeClass('show');
    setTimeout(function() {
        message.closest('.add-to-cart-message').remove();
    }, 300);
}

function addLoading(elem) {
    elem.addClass('loading-circle');
}

function removeLoading(elem) {
    elem.removeClass('loading-circle');
}

function initCookieNotification() {
    var agreed = getCookie('cookie-policy-agreed');
    var wrap = $('#cookie-notification');
    var agreeButton = $('.agree', wrap);

    if (!agreed) {
        $('#cookie-notification').addClass('show');
    }

    agreeButton.on('click', function() {
        wrap.removeClass('show');
        setCookie('cookie-policy-agreed', true, false);
        return false;
    });
}

function setCookie(key, value, time) {
    if (time) {
        var expires = new Date();
        expires.setTime(expires.getTime() + time * 1000);
        document.cookie =
            key +
            '=' +
            value +
            (expires ? ';expires=' + expires.toUTCString() : '');
    } else {
        document.cookie = key + '=' + value + ';';
    }
}

function getCookie(key) {
    var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return keyValue ? keyValue[2] : false;
}

function addToCompare(data) {
    var compareContainer = $('#compare-container');
    var compareProducts = $('#compare-products');

    var html = '<div class="compare-product">';
    html += '<img src="' + data.image + '">';
    html += '<a href="#remove" class="remove"><i class="dt dt-close"></i></a>';
    html += '</div>';

    compareProducts.append(html);
    compareContainer.addClass('has-products');
}

$('#compare-toggler').click(function() {
    $('#compare-container').toggleClass('show');
    return false;
});

var locationCoords, geocoder, mapObject, infowindow, currentMarker;

var allMapMarkers = [];

function initLocationAutocomplete() {
    var autocompleteInput = $('#autocomplete-location');

    autocompleteObj = new google.maps.places.Autocomplete(
        document.getElementById('autocomplete-location'),
        {
            types: ['geocode']
        }
    );

    autocompleteObj.addListener('place_changed', processSelectedAddress);

    $('#autocomplete-location').on('keyup', function(e) {
        var keyCode = e.keyCode || e.which;
        if (keyCode === 13) {
            forceGeocode();
            e.preventDefault();
        }
    });

    $('#autocomplete-location').on('keypress', function(e) {
        var keyCode = e.keyCode || e.which;
        if (keyCode === 13) {
            e.preventDefault();
            return false;
        }
    });

    $('#submit-autocomplete').click(function() {
        forceGeocode();
    });
}

function processSelectedAddress() {
    addressObject = autocompleteObj.getPlace();

    if (typeof addressObject.geometry == 'undefined') {
        return;
    }

    locationCoords = {
        lat: addressObject.geometry.location.lat(),
        lng: addressObject.geometry.location.lng()
    };

    map.setCenter(locationCoords);
}

function initPackageGoogleMap(map, markers, mapZoom, currentpos) {
    locationCoords = currentpos;
    getAddressFromPosition(currentpos);

    mapObject = new google.maps.Map(map, {
        zoom: mapZoom,
        center: locationCoords,
        mapTypeControl: false,
        gestureHandling: 'greedy'
    });

    infowindow = new google.maps.InfoWindow({
        content: 'holding...',
        maxWidth: 300
    });

    $.each(markers, function() {
        putMarkerOnMap(this);
    });

    putMarkerOnMap(
        {
            coords: locationCoords,
            defaultIcon: '/images/html/current_location.svg'
        },
        true
    );

    google.maps.event.addListener(infowindow, 'domready', function() {
        $('.pin-desc')
            .closest('.gm-style-iw')
            .parent()
            .addClass('custom-iw');
    });
}

function putMarkerOnMap(marker, current) {
    map = mapObject;

    var mapMarker = new google.maps.Marker({
        position: marker.coords,
        map: map,
        draggable: false,
        icon: marker.defaultIcon ? marker.defaultIcon : false,
        defaultIcon: marker.defaultIcon ? marker.defaultIcon : false,
        selectedIcon: marker.selectedIcon ? marker.selectedIcon : false,
        customProperties: marker.customProperties
    });

    if (current) {
        currentMarker = mapMarker;
    } else {
        allMapMarkers.push(mapMarker);
    }

    google.maps.event.addListener(mapMarker, 'click', function() {
        for (var i in allMapMarkers) {
            if (allMapMarkers.hasOwnProperty(i)) {
                allMapMarkers[i].setIcon(allMapMarkers[i].defaultIcon);
                infowindow.close();
            }
        }
        mapMarker.setIcon(mapMarker.selectedIcon);

        processPackagePointSelect(this);
    });

    if (marker.desc) {
        google.maps.event.addListener(mapMarker, 'click', function() {
            infowindow.setContent(marker.desc);
            infowindow.open(map, this);
        });
    }
}

function forceGeocode() {
    geocoder = geocoder ? geocoder : new google.maps.Geocoder();
    geocoder.geocode(
        {
            address: $('#autocomplete-location').val()
        },
        function(results, status) {
            var result = results[0];

            locationCoords = {
                lat: result.geometry.location.lat(),
                lng: result.geometry.location.lng()
            };

            map.setCenter(locationCoords);
            removeMarkerFromMap(currentMarker);
            putMarkerOnMap(
                {
                    coords: locationCoords,
                    defaultIcon: '/images/html/current_location.svg'
                },
                true
            );

            formattedAddress = result['formatted_address'];
            $('#autocomplete-location').val(formattedAddress);
        }
    );
    return false;
}

function removeMarkerFromMap(marker) {
    marker.setMap(null);
}

function getAddressFromPosition(pos) {
    geocoder = geocoder ? geocoder : new google.maps.Geocoder();

    geocoder.geocode(
        {
            latLng: pos
        },
        function(responses) {
            var result = responses[0];

            formattedAddress = result['formatted_address'];
            $('#autocomplete-location').val(formattedAddress);
        }
    );
}

function initMobileActions() {
    $('#header .action-toggle').click(function() {
        if ($(this).siblings('.action-menu').length > 0) {
            overlay.data('caller', $(this).attr('id'));
            overlay.toggleClass(
                'show',
                !$(this)
                    .siblings('.action-menu')
                    .eq(0)
                    .hasClass('visible')
            );
        }
    });
}
